import { http } from '../../../api'

const dashboard = {
  namespaced: true,
  state: {
    countUsers: {},
    newUsers: [],
    unseenCertificateCount: 0,
    totalUsers: 0
  },
  actions: {
    getDashboardData: ({ commit }, params) => {
      return http.get('/dashboard', params).then(res => {
        commit('setDashboardData', res.data)
        return res.data
      })
    }
  },
  mutations: {
    setDashboardData (state, data) {
      state.unseenCertificateCount = data.unseenCertificateCount
    }
  }
}

export default dashboard
